module.exports = __webpack_public_path__ + "static/media/49.6ac54b87.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/49.png
// module id = 621
// module chunks = 0